export default __webpack_public_path__ + "static/media/slider-unraf-2.b2636050.jpg";